<template>
  <div class="MapLatLon">
    <div class="p-line"></div>
    <!-- <div class="p-lable">地图基础属性</div> -->
    <div class="p-opacityslider-wrap">
      <div class="center">
        <p>空气质量城市定位(保留小数点后2位)</p>
        <div class="lngandlat">
          <div class="LngLatName">经度:</div>
          <el-input placeholder="经度(保留小数点后2位)" v-model="value.lon" @change="changeSetting">
          </el-input>
          <div class="LngLatName left">纬度:</div>
          <el-input placeholder="纬度(保留小数点后2位)" v-model="value.lat" @change="changeSetting">
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapLatLon',
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  // watch: {
  //   propertyData: {
  //     deep: true,
  //     handler: function (newValue) {
  //       console.log(newValue);
  //       this.value.zoom = newValue.headerLngLatData.value;
  //     },
  //   },
  // },
  data() {
    return {
      value: '',
    };
  },
  mounted() {
    this.value = this.propertyData[this.propertyDataKey].value;
  },
  methods: {
    changeSetting() {
      console.log(this.value);
      /* 更新数据 */

      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: this.value,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.MapLatLon {
  width: 100%;
  margin-bottom: 15px;
  margin-top: 15px;
  box-sizing: border-box;
  // padding: 0 10px;
  .p-lable {
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    color: #5b5c66;
    font-size: 12px;
    line-height: 30px;
  }
}
.demo-input-label {
  display: inline-block;
  width: 130px;
}
.center > {
  div {
    display: flex;
    align-items: center;
    padding: 0 15px;
  }
  p {
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 20px;
    color: #a0a1b4;
    font-size: 14px;
    line-height: 20px;
  }
  .lngandlat {
    display: flex;
    align-items: center;
    padding: 0 15px;
    font-size: 14px;
    :deep() input {
      color: #ffffff;
    }
    .LngLatName {
      width: 104px;
      font-size: 12px;
    }
    .left {
      padding-left: 6px;
    }
    img {
      // padding: 0 10px;
      width: 26px;
      height: 26px;
      margin-left: 5px;
    }

    span {
      margin: 0 5px;
    }
  }
}
.center {
  margin-bottom: 10px;
  .el-input {
    display: flex;
    align-items: center;
    display: inline-block;
    height: 38px;
    width: 160px;
    :deep(input) {
      border-radius: 0;
      height: 28px;
      width: 100%;
      background: #191b23;
      border: 1px solid #5e6167;
      padding: 0 10px;
      font-size: 12px;
    }
  }
}
// .zoom > {
//   div {
//     display: flex;
//     align-items: center;
//   }
//   p {
//     box-sizing: border-box;
//     width: 50px;
//     height: 30px;
//     color: #a0a1b4;
//     font-size: 14px;
//     line-height: 30px;
//   }
// }
// .zoom {
//   padding: 0 15px;
//   display: flex;
//   align-items: center;
//   .el-select {
//     width: 192px;

//     :deep() input {
//       color: #ffffff;
//       background: #191b23;
//       border-radius: 0;
//       border-collapse: collapse;
//       text-align: center;
//       border: 1px solid rgb(90, 90, 90);

//       &:hover {
//         border: 1px solid #3179ff;
//       }
//       &:focus {
//         border: 1px solid #3179ff;
//       }
//     }
//   }
// }
// .is3d > {
//   div {
//     display: flex;
//     align-items: center;
//   }
//   p {
//     box-sizing: border-box;
//     width: 150px;
//     height: 30px;
//     color: #a0a1b4;
//     font-size: 14px;
//     line-height: 30px;
//   }
// }
// .is3d {
//   padding: 10px 15px;
//   padding-bottom: 0px;
//   display: flex;
//   align-items: center;
//   .el-select {
//     width: 192px;

//     :deep() input {
//       color: #ffffff;
//       background: #191b23;
//       border-radius: 0;
//       border-collapse: collapse;
//       text-align: center;
//       border: 1px solid rgb(90, 90, 90);

//       &:hover {
//         border: 1px solid #3179ff;
//       }
//       &:focus {
//         border: 1px solid #3179ff;
//       }
//     }
//   }
// }
</style>
